export const FETCH_PRESCRIPTIONS_SUCCESS = 'FETCH_PRESCRIPTIONS_SUCCESS';
export const FETCH_PRESCRIPTIONS_FAIL ='FETCH_PRESCRIPTIONS_FAIL';
export const FETCH_PRESCRIPTIONS_START = 'FETCH_PRESCRIPTIONS_START';

export const ADD_PRESCRIPTION_START = 'ADD_PRESCRIPTION_START';
export const ADD_PRESCRIPTION_SUCCESS = 'ADD_PRESCRIPTION_SUCCESS';
export const ADD_PRESCRIPTION_FAIL = 'ADD_PRESCRIPTION_FAIL';
